import { Component, h, Prop, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'workflow-view-footer',
  styleUrl: 'workflow-view-footer.css',
})
export class WorkflowViewFooter {
  @Prop() detailsExpanded: boolean = false;

  @Event() detailsExpandedChange: EventEmitter<boolean>;

  handleTabClick(isDetails: boolean) {
    this.detailsExpandedChange.emit(isDetails);
  }

  render() {
    return (
      <ion-footer class="workflow-view-footer">
        <ion-toolbar class="workflow-view-footer__toolbar">
          <div class="workflow-view-footer__buttons-container">
            <ion-buttons>
              <ion-button fill="clear" class={!this.detailsExpanded ? 'footer-button-active' : 'footer-button-inactive'} onClick={() => this.handleTabClick(false)}>
                <div class="workflow-view-footer__button-content">
                  <ion-icon name="chatbox-outline"></ion-icon>
                  <span>Thread</span>
                </div>
              </ion-button>

              <ion-button fill="clear" class={this.detailsExpanded ? 'footer-button-active' : 'footer-button-inactive'} onClick={() => this.handleTabClick(true)}>
                <div class="workflow-view-footer__button-content">
                  <ion-icon name="information-circle-outline"></ion-icon>
                  <span>Details</span>
                </div>
              </ion-button>
            </ion-buttons>
          </div>
        </ion-toolbar>
      </ion-footer>
    );
  }
}
